import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PluginHeaderButtonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginHeaderButtons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CurrentBoardFull"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiddenPluginBoardButtons"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginHeaderButtons","document":PluginHeaderButtonsDocument}} as const;
export type PluginHeaderButtonsQueryVariables = Types.Exact<{
  idBoard: Types.Scalars['ID'];
}>;


export type PluginHeaderButtonsQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & { prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Types.Board_Prefs, 'hiddenPluginBoardButtons'>
    )> }
  )> }
);




/**
 * __usePluginHeaderButtonsQuery__
 *
 * To run a query within a React component, call `usePluginHeaderButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginHeaderButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginHeaderButtonsQuery({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *   },
 * });
 */
export function usePluginHeaderButtonsQuery(baseOptions: Apollo.QueryHookOptions<PluginHeaderButtonsQuery, PluginHeaderButtonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PluginHeaderButtonsQuery, PluginHeaderButtonsQueryVariables>(PluginHeaderButtonsDocument, options);
      }
export function usePluginHeaderButtonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PluginHeaderButtonsQuery, PluginHeaderButtonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PluginHeaderButtonsQuery, PluginHeaderButtonsQueryVariables>(PluginHeaderButtonsDocument, options);
        }
export type PluginHeaderButtonsQueryHookResult = ReturnType<typeof usePluginHeaderButtonsQuery>;
export type PluginHeaderButtonsLazyQueryHookResult = ReturnType<typeof usePluginHeaderButtonsLazyQuery>;
export type PluginHeaderButtonsQueryResult = Apollo.QueryResult<PluginHeaderButtonsQuery, PluginHeaderButtonsQueryVariables>;